import type { ReactNode } from 'react';

import DataTable from './DataTable';
import type { DataTableColumnDef } from './features';

export interface KeyValueRow {
    /** Stable identity of the row. */
    key: string;
    label: ReactNode;
    value: ReactNode;
}

interface KeyValueTableProps {
    rows: KeyValueRow[];
    density?: 'regular' | 'compact';
    className?: string;
    /** Applied to the `<table>`. */
    tableClassName?: string;
    'aria-label'?: string;
}

const COLUMNS: DataTableColumnDef<KeyValueRow>[] = [
    { id: 'label', cell: ({ row }) => row.original.label, enableSorting: false },
    { id: 'value', cell: ({ row }) => row.original.value, enableSorting: false },
];

/** Labels beside their values, no header row: a DataTable in its key-value variant. */
export default function KeyValueTable(props: KeyValueTableProps) {
    const { rows, density, className, tableClassName } = props;
    return (
        <DataTable
            data={rows}
            columns={COLUMNS}
            getRowId={(row) => row.key}
            variant="keyValue"
            density={density}
            enableSorting={false}
            className={className}
            tableClassName={tableClassName}
            aria-label={props['aria-label']}
        />
    );
}
